export default __webpack_public_path__ + "static/media/ExitWhoosh.9d62a4e3.mp3";